import React from "react";
import { Sprite } from "@pixi/react";
import * as PIXI from "pixi.js";
import { ASSET_NAME } from "../../../../assets";
import { useDimensions } from "../../../../Contexts/DimensionsContext";
import { USER_INTERFACE_BUTTON_CONFIG } from "../../../../textureConfigs";
import { PixiSettings } from "../../../../pixiSettings";

// Company logo configuration - matches UI logo dimensions
const COMPANY_LOGO_CONFIG = {
  BASE_WIDTH: 175,
  BASE_HEIGHT: 34,
  DEVICE_CONFIGS: {
    [PixiSettings.DEVICE.MOBILE]: {
      [PixiSettings.ORIENTATION.PORTRAIT]: {
        deviceMultiplier: 1.1,
      },
      [PixiSettings.ORIENTATION.LANDSCAPE]: {
        deviceMultiplier: 0.85,
      },
    },
    [PixiSettings.DEVICE.TABLET]: {
      [PixiSettings.ORIENTATION.PORTRAIT]: {
        deviceMultiplier: 1.2,
      },
      [PixiSettings.ORIENTATION.LANDSCAPE]: {
        deviceMultiplier: 0.9,
      },
    },
    [PixiSettings.DEVICE.DESKTOP]: {
      deviceMultiplier: 0.53,
    },
  },
};

const CompanyLogo = ({ toolbar }) => {
  const { getResponsiveConfig, device, orientation, dimensions } =
    useDimensions();
  const texture = PIXI.Assets.get(ASSET_NAME.popi_company_logo);

  // Get responsive configuration from context
  const logoConfig = getResponsiveConfig(COMPANY_LOGO_CONFIG, true);
  const buttonConfig = getResponsiveConfig(USER_INTERFACE_BUTTON_CONFIG, true);

  // Get logo position based on device and orientation (similar to PixiButtonSound)
  const getLogoPosition = () => {
    let x = toolbar.width / 2; // Default center
    let y = toolbar.centerY; // Default center Y

    if (device === PixiSettings.DEVICE.MOBILE) {
      if (orientation === PixiSettings.ORIENTATION.PORTRAIT) {
        x = buttonConfig.width * 2.5;
        y = buttonConfig.height * 0.8;
      } else {
        // Landscape
        x = toolbar.width - buttonConfig.width * 1.275;
        y = buttonConfig.height * 0.3;
      }
    } else if (device === PixiSettings.DEVICE.TABLET) {
      if (orientation === PixiSettings.ORIENTATION.PORTRAIT) {
        x = buttonConfig.width * 2.5;
        y = buttonConfig.height * 0.8;
      } else {
        // Landscape
        x = buttonConfig.width * 2.0;
        y = dimensions.height - buttonConfig.height * 2.25;
      }
    } else {
      // Desktop
      x = buttonConfig.width * 3.5;
      y = dimensions.height - buttonConfig.height * 2.2;
    }

    return { x, y };
  };

  const logoPosition = getLogoPosition();

  return (
    <Sprite
      name="secondary_company_logo"
      x={logoPosition.x}
      y={logoPosition.y}
      zIndex={3}
      texture={texture}
      anchor={0.5}
      width={logoConfig.width}
      height={logoConfig.height}
      resolution={2}
    />
  );
};

export default CompanyLogo;
